import { createTranslationRef } from '@backstage/core-plugin-api/alpha';

/**
 * Strings of the "delete infra" action of the IaC tab. Only the strings added
 * with that action go through i18n; the rest of this plugin predates it and
 * still hardcodes Spanish (migrating it is out of scope).
 *
 * English defaults here; the app registers the `en` and `es` resources in
 * `packages/app/src/components/translation/autom2plataforma/`.
 *
 * @alpha
 */
export const autom2plataformaTranslationRef = createTranslationRef({
  id: 'autom2plataforma',
  messages: {
    deleteInfra: {
      actionsColumn: 'Actions',
      button: 'Destroy infra',
      notDeletableTooltip:
        'Only successfully finished infrastructures can be deleted',
      dialog: {
        title: 'Destroy infrastructure',
        warningTitle: 'Destructive and IRREVERSIBLE action',
        warningBody:
          'This launches the deletion of this infrastructure in AUTOM2PLATAFORMA: every one of its resources will be torn down and the data they hold will be lost forever. There is no way to undo it.',
        cdWarning:
          'Repositories with CD configured against this infrastructure will no longer be able to deploy. Their CD configuration is NOT removed automatically: it has to be cleaned up by hand.',
        cd: {
          checking:
            'Checking which repositories have CD for this infrastructure…',
          none: 'No repository has CD configured against this infrastructure on branch {{branch}}.',
          listIntro:
            'These repositories have CD configured against this infrastructure (branch {{branch}}). They will no longer be able to deploy and their CD configuration is NOT removed automatically: it has to be cleaned up by hand.',
          listIntroOn:
            'These repositories have CD configured against this infrastructure (branch {{branch}}). Their CD configuration for the listed environment WILL be removed when you accept, and they will no longer be able to deploy.',
          listChanged:
            'The list of repositories changed while you were reviewing it. Check the updated list and press Accept again to confirm it.',
          blocked:
            'The CD configuration cannot be removed safely right now. You can cancel, or destroy the infrastructure without removing the CD configuration (it will have to be cleaned up by hand).',
          repoRow: '{{repository}} · {{environment}}',
          otherInfra:
            'It also references another infrastructure in {{environments}}; that folder will not be affected.',
          incomplete:
            'The check is incomplete: there may be more repositories that are not shown.',
          scanFailed:
            'Could not check which repositories have CD against this infrastructure. Review it by hand before continuing.',
        },
        infraLabel: 'Infrastructure to destroy',
        environmentLabel: 'Environment',
        cancel: 'Cancel',
        confirm: 'Accept deletion',
        confirmSkipCd: 'Destroy without removing the CD',
        confirming: 'Launching deletion…',
      },
      success:
        'Deletion of {{name}} launched. The infrastructure no longer appears in the list.',
      successWithCd_one:
        'Deletion of {{name}} launched. The CD configuration of {{count}} repository is being removed.',
      successWithCd_other:
        'Deletion of {{name}} launched. The CD configuration of {{count}} repositories is being removed.',
      errors: {
        notDestroyable:
          'This infrastructure cannot be destroyed from Backstage: its creation data is incomplete (it was created before that data was stored, or it lacks the identifiers returned by the platform), or your corporate email could not be resolved. Nothing has been changed. Contact a platform administrator.',
        forbidden:
          'Only Backstage platform administrators can destroy an infrastructure.',
        notFound:
          'This infrastructure no longer exists or has already been destroyed.',
        conflict:
          'This infrastructure cannot be destroyed right now: it is either still being provisioned or someone else has already destroyed it.',
        launchRejected:
          'AUTOM2PLATAFORMA did not accept the deletion request, so the infrastructure itself has not been destroyed. If it is still in the list, try again later; if it has disappeared, tell a platform administrator, because Backstage may be hiding it even though it still exists.',
        generic: 'The deletion could not be launched (HTTP {{status}}).',
      },
    },
  },
});
